<template>
  <v-container fluid>
    <v-row
      :class="
        $store.state.isMobile
          ? 'actions align-center'
          : 'actions align-center flex-row-reverse'
      "
      :justify="$store.state.isMobile ? 'start' : 'space-between'"
    >
      <v-col class="back-arrow" cols="auto">
        <v-btn
          variant="text"
          class="ma-0"
          density="compact"
          :icon="$store.state.isMobile ? 'mdi-chevron-left' : 'mdi-close'"
          @click="this.$emit('update:modelValue', false)"
          :disabled="loading"
        >
        </v-btn>
      </v-col>
      <v-col class="task-add" cols="auto">
        <h3
          :style="
            $store.state.isMobile
              ? 'font-size: 18px; font-weight: 400'
              : 'font-size: 24px; font-weight: 600'
          "
        >
          Настройки
        </h3>
      </v-col>
    </v-row>
    <v-row class="mb-4">
      <v-col :cols="$store.state.isMobile ? 'auto' : 6">
        <v-row>
          <v-col>
            <v-sheet border min-height="200" class="pa-4" rounded="xl">
              <v-list-item-subtitle style="font-size: 14px; color: #8e8e93"
                >Аккаунты</v-list-item-subtitle
              >
              <v-list density="compact" nav color="#10A6F2">
                <v-list-item
                  rounded="xl"
                  nav
                  :value="mailItem"
                  v-for="mailItem in $store.state.mailbox"
                  :key="mailItem.title"
                  @click="handleItemClick(mailItem)"
                  :active="selectNav[0] === mailItem"
                  :disabled="loading"
                  style="font-size: 16px"
                >
                  <template v-slot:prepend>
                    <v-icon
                      class="mr-2"
                      icon="mdi-gmail"
                      size="36px"
                      color="#2CA6F7"
                    >
                    </v-icon>
                    {{ mailItem.title }}
                  </template>
                </v-list-item>
                <v-list-item
                  @click="addMailBox"
                  rounded="xl"
                  style="font-size: 16px"
                >
                  <template v-slot:prepend>
                    <v-icon icon="mdi-plus" color="#2CA6F7" class="mr-2">
                    </v-icon>
                    Добавить учетную запись
                  </template>
                </v-list-item>
              </v-list>
            </v-sheet>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-sheet border min-height="100" class="pa-4" rounded="xl">
              <v-list-item-subtitle style="font-size: 14px; color: #8e8e93"
                >Общие</v-list-item-subtitle
              >
              <v-list-item
                @click="console.log('add acc')"
                rounded="xl"
                :disabled="loading"
                style="font-size: 16px"
              >
                <template v-slot:prepend>
                  <v-icon class="mr-2">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.9997 11.3246C11.1846 11.3246 10.6412 11.868 10.6412 12.6831C10.6412 13.2265 11.0488 13.634 11.4563 13.7699L11.0488 15.6718H12.8148L12.4073 13.7699C12.9507 13.634 13.2224 13.2265 13.2224 12.6831C13.3582 11.868 12.8148 11.3246 11.9997 11.3246ZM12.1356 5.48304C11.1846 5.48304 10.2337 6.16229 10.2337 7.11324V9.15098H13.9016V7.11324C13.7658 6.16229 13.0865 5.48304 12.1356 5.48304ZM11.9997 1L2.49023 5.07549V9.15098C2.62608 15.1284 6.42987 20.4265 11.9997 22.6001C17.5695 20.4265 21.3733 15.1284 21.5092 9.15098V5.07549L11.9997 1ZM17.4337 15.9435C17.4337 16.7586 16.8903 17.302 16.0752 17.302H7.92422C7.10912 17.302 6.56572 16.7586 6.56572 15.9435V10.5095C6.56572 9.69438 7.10912 9.15098 7.92422 9.15098H8.33177V7.11324C8.46762 5.21134 10.0978 3.71699 11.9997 3.71699C13.9016 3.71699 15.5318 5.21134 15.6677 7.11324V9.15098H16.0752C16.8903 9.15098 17.4337 9.69438 17.4337 10.5095V15.9435Z"
                        fill="#A6ACB5"
                      />
                    </svg>
                  </v-icon>
                  Параметры конфиденциальности
                </template>
              </v-list-item>
              <v-list-item
                @click="console.log('add acc')"
                rounded="xl"
                :disabled="loading"
                style="font-size: 16px"
              >
                <template v-slot:prepend>
                  <v-icon icon="mdi-help-circle" class="mr-2"> </v-icon>
                  Свяжитесь с нами
                </template>
              </v-list-item>
            </v-sheet>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6" v-if="accauntEdit && !$store.state.isMobile">
        <div>
          <v-sheet
            border
            rounded="xl"
            min-height="200"
            class="pa-4 mb-4"
            style="align-content: center"
          >
            <v-row justify="start" align="center">
              <v-col cols="auto">
                <v-icon icon="mdi-gmail" size="62px" color="#2CA6F7"> </v-icon>
              </v-col>
              <v-col style="align-self: center">
                <v-list-item-title>
                  {{ selectNav[0].title }}
                </v-list-item-title>
              </v-col>
            </v-row>
            <!--<v-row justify="space-between">
              <v-col cols="9">
                <v-list-item-title> Синхронизация эл. почты </v-list-item-title>
                <v-list-item-subtitle>
                  Последняя синхронизация: 21.01.2025 12:02
                </v-list-item-subtitle>
              </v-col>
              <v-col cols="auto">
                <v-switch
                  color="#2CA6F7"
                  v-model="accTrue"
                  hide-details
                  inset
                ></v-switch>
              </v-col>
            </v-row>-->
          </v-sheet>
          <v-sheet border rounded="xl" class="pa-4">
            <v-row>
              <v-col cols="auto">
                <v-list-item
                  @click="deleteMailBox"
                  color="red"
                  rounded="xl"
                  :disabled="loading"
                >
                  <v-list-item-title style="color: red">
                    <v-icon icon="mdi-trash-can"></v-icon>
                    Удалить учетную запись
                  </v-list-item-title>
                </v-list-item>
              </v-col>
            </v-row>
          </v-sheet>
        </div>
      </v-col>
    </v-row>

    <v-dialog v-model="accauntEdit" fullscreen v-if="$store.state.isMobile">
      <v-card
        class="pa-4"
        v-touch="{
          right: () => (accauntEdit = false),
        }"
      >
        <template class="d-flex actions align-center mb-4" justify="start">
          <v-btn
            variant="text"
            class="ma-0 mr-4"
            density="compact"
            icon="mdi-chevron-left"
            @click="accauntEdit = false"
            :disabled="loading"
          >
          </v-btn>

          <h3>{{ selectNav[0].title }}</h3>
        </template>
        <v-sheet border rounded="xl" min-height="200" class="pa-4 mb-4">
          <v-row justify="center">
            <v-col cols="3">
              <v-icon class="mr-2" icon="mdi-gmail" size="62px"> </v-icon>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="5">
              <v-list-item-title> {{ selectNav[0].title }} </v-list-item-title>
            </v-col>
          </v-row>
        </v-sheet>
        <!--<v-sheet border rounded="xl" class="pa-4 mb-4">
          <v-row justify="space-between">
            <v-col cols="9">
              <v-list-item-title> Синхронизация эл. почты </v-list-item-title>
              <v-list-item-subtitle>
                Последняя синхронизация: 21.01.2025 12:02
              </v-list-item-subtitle>
            </v-col>
            <v-col cols="auto">
              <v-switch
                color="#2CA6F7"
                v-model="accTrue"
                hide-details
                inset
              ></v-switch>
            </v-col>
          </v-row>
        </v-sheet>-->
        <v-sheet border rounded="xl" class="pa-4">
          <v-row>
            <v-col cols="auto">
              <v-list-item
                @click="deleteMailBox"
                color="red"
                rounded="xl"
                :disabled="loading"
              >
                <v-list-item-title style="color: red; font-size: 14px">
                  <v-icon icon="mdi-trash-can" size="24px"></v-icon>
                  Удалить учетную запись
                </v-list-item-title>
              </v-list-item>
            </v-col>
          </v-row>
        </v-sheet>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "Setting-component",
  props: {
    modelValue: Boolean,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      loading: false,
      selectNav: [],
      accauntEdit: false,
      accTrue: true,
    };
  },
  methods: {
    handleItemClick(item) {
      // Если кликнули на уже выбранный элемент, ничего не делаем
      if (this.selectNav[0] === item) {
        return;
      }
      // Иначе обновляем выбранный элемент
      this.selectNav = [item];
      this.accauntEdit = true;
    },
    async deleteMailBox() {
      if (window.BX24) {
        console.log("Библиотека Bitrix24 загружена");
        window.BX24.init(async () => {
          const callBXMethod = (method, params) =>
            new Promise((resolve, reject) => {
              window.BX24.callMethod(method, params, function (result) {
                if (result.error()) {
                  reject(result.error());
                } else {
                  resolve(result.data());
                }
              });
            });
          this.loading = true;

          const index = this.$store.state.mailbox.findIndex(
            (e) => e.title == this.selectNav[0].title
          );
          const indexSetting = this.$store.state.mailboxSetting.findIndex(
            (e) => e.title == this.selectNav[0].title
          );

          this.$store.commit("deleteBox", index);
          this.$store.commit("deleteMailboxSetting", indexSetting);

          if (this.$store.state.mailboxSetting.length > 0) {
            this.$emit("update:modelValue", false);
            this.$emit("deleteSetting", this.$store.state.mailbox[0]);
          } else {
            this.$store.commit("setAuth", false);
          }

          const mailboxUser = await callBXMethod("entity.item.get", {
            ENTITY: "MailFlow",
            FILTER: {
              PROPERTY_email: this.selectNav[0].title,
            },
            START: -1,
          });
          console.log({ mailboxUser });
          await callBXMethod("entity.item.delete", {
            ENTITY: "MailFlow",
            ID: mailboxUser[0].ID,
          });
          this.loading = false;
        });
      } else {
        this.loading = true;
        const index = this.$store.state.mailbox.findIndex(
          (e) => e.title == this.selectNav[0].title
        );
        const indexSetting = this.$store.state.mailboxSetting.findIndex(
          (e) => e.title == this.selectNav[0].title
        );

        this.$store.commit("deleteBox", index);
        this.$store.commit("deleteMailboxSetting", indexSetting);

        if (this.$store.state.mailboxSetting.length > 0) {
          this.$emit("update:modelValue", false);
          this.$emit("deleteSetting", this.$store.state.mailbox[0]);
        } else {
          this.$store.commit("setAuth", false);
        }

        localStorage.removeItem("imapSettings");

        if (this.$store.state.mailboxSetting.length > 0) {
          const formDataString = JSON.stringify(
            this.$store.state.mailboxSetting
          );
          localStorage.setItem("imapSettings", formDataString);
        }
        this.loading = false;
      }
    },
    async addMailBox() {
      await this.$store.commit("setAuth", false);
      await this.$store.commit("setNewBox", true);
      this.$router.push("/auth");
    },
  },
};
</script>
